module.exports = __webpack_public_path__ + "img/photo_2024-04-12_22-33-35.cb125c47.jpg";